import { Chat01Icon, Note01Icon, UserGroupIcon } from "@hugeicons/core-free-icons";
import type { NavEntry } from "@/components/nancy/settings-shell";

export type ShelbySectionId = "answering" | "contact" | "instructions";

export const SHELBY_SECTIONS: readonly ShelbySectionId[] = ["answering", "contact", "instructions"];

export const shelbySections: readonly (NavEntry & { id: ShelbySectionId })[] = [
  {
    id: "answering",
    label: "Answering",
    icon: Chat01Icon,
    description:
      "She answers on the same texting line the front desk uses. Nothing here changes what a caller hears on the phone.",
  },
  {
    id: "contact",
    label: "Who she pulls in",
    icon: UserGroupIcon,
    description:
      "Her whole job is getting this person onto the conversation. They are texted a brief and a link to the thread the moment she takes one.",
  },
  {
    id: "instructions",
    label: "What she is told",
    icon: Note01Icon,
    description:
      "Added to her instruction, after everything above. Facts about the place belong in the front desk's knowledge base, since she reads the same one.",
  },
];
